import { render, staticRenderFns } from "./DoctorEditor.vue?vue&type=template&id=75590f41&"
import script from "./DoctorEditor.vue?vue&type=script&lang=ts&"
export * from "./DoctorEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports